module.exports = {
      id: "search-usage",
      viewBox: "0 0 21.5 21.5",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }